import { render, staticRenderFns } from "./RDRefill.vue?vue&type=template&id=36b4927c&"
import script from "./RDRefill.vue?vue&type=script&lang=ts&"
export * from "./RDRefill.vue?vue&type=script&lang=ts&"
import style0 from "./RDRefill.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QPageContainer,QCard});
